export default {
  meta: {
    title: $localize`:@@meta.jackpot.history.title:История Jackpot`,
    description: $localize`:@@meta.jackpot.history.desc:Самые высокие банки и интересные сражения, выиграть можно даже с шансом меньше 1% и сорвать куш, забрав все сочные скины в этом раунде.`
  }
};